import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/img/silae-papillon.svg'
import _imports_1 from '../assets/img/logo-acdemy.svg'


const _hoisted_1 = { class: "ef-login" }
const _hoisted_2 = { class: "ef-login__left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ef-login__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "logo",
    src: _imports_0
  })
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-lock" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  version: "1.1",
  id: "L3",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 0 0",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    stroke: "#1d467c",
    "stroke-width": "4",
    cx: "50",
    cy: "50",
    r: "44",
    style: {"opacity":"0.5"}
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "#1d467c",
    stroke: "#1d467c",
    "stroke-width": "3",
    cx: "8",
    cy: "54",
    r: "6"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      dur: "1s",
      type: "rotate",
      from: "0 50 48",
      to: "360 50 52",
      repeatCount: "indefinite"
    })
  ])
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-circle-check" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 3 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-xmark" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "ef-login__formTitle" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Bienvenue !"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Connectez vous à votre espace formation"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Se connecter")
const _hoisted_18 = {
  key: 1,
  class: "ef-login__loading"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  version: "1.1",
  id: "L3",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 0 0",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    stroke: "#1d467c",
    "stroke-width": "4",
    cx: "50",
    cy: "50",
    r: "44",
    style: {"opacity":"0.5"}
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "#1d467c",
    stroke: "#1d467c",
    "stroke-width": "3",
    cx: "8",
    cy: "54",
    r: "6"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      dur: "1s",
      type: "rotate",
      from: "0 50 48",
      to: "360 50 52",
      repeatCount: "indefinite"
    })
  ])
], -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Chargement de votre espace ... ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

import {ref} from "vue";
import {useRouter} from 'vue-router';
import {storeUser} from "@/stores/user";
import {storeSystem} from "@/stores/system";
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import FormTemplate from '@/components/FormTemplate.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loader = ref(false);

//V-MODEL
const model = ref([
  { type: "text", placeholder: "Adresse e-mail", field: "email", value: '' },
  { type: "password", placeholder: "Mot de passe", field: "password", value: '' },
]);

const _storeUser = storeUser();
const router = useRouter();
const _storeSystem = storeSystem();

const anim = ref('');

const login = () => {
  loader.value = true;
  anim.value = '-loading';
  _storeUser.login(model.value[0].value, model.value[1].value).then((response) => {
    if (response.status === 200) {
      loader.value = false;
      anim.value = '-success';
      setTimeout(() => {
        _storeUser.fillInfos(response.data.user, response.data.user.preferences, response.data.token.s);
        router.push('home');
      }, 1000);
    } else {
      loader.value = false;
      anim.value = '-failed';
      /*_storeSystem.addInfoTag({id: '', type: 'failure', text: 'Echec de la connexion'})*/
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("img", {
        class: _normalizeClass(`ef-login__title ${anim.value}`),
        alt: "logo",
        src: _imports_1
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(`ef-login__right ${anim.value}`)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`ef-login__anim ${anim.value}`)
        }, [
          (!loader.value && anim.value === '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : (loader.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : (anim.value === '-success')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
        ], 2),
        (anim.value !== '-success')
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (login()), ["prevent"]))
            }, [
              _hoisted_16,
              _createVNode(FormTemplate, { inputs: model.value }, {
                default: _withCtx(({ errorCount }) => [
                  _createVNode(Button, {
                    disabled: errorCount !== 0,
                    type: "submit"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 2
                  }, 1032, ["disabled"])
                ]),
                _: 1
              }, 8, ["inputs"])
            ], 32))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
      ], 2)
    ])
  ]))
}
}

})